<template>
    <div>
        <form-group label="Select crew" name="attached_employee_user">
            <div class="select">
                <select name="attached_employee_user" class="input" v-model="attached_employee_user">
                    <option value="">Select crew</option>
                    <option v-for="user in userList" :value="user.id">
                        {{user.employee_id && `${user.employee_id} - `}}
                        {{user.name}}
                        {{user.client_id && `(${user.client_id})`}}
                    </option>
                </select>
            </div>
        </form-group>
        <form-group label="Start Date" name="start_date" v-if="attached_employee_user">
            <datepicker
                    placeholder="Select start date"
                    id="start_date"
                    name="start_date"
                    :min-date="minStartDate"
                    :max-date="maxStartDate"
                    v-model="start_date"
            />
        </form-group>

        <form-group label="End Date" name="end_date" v-if="start_date">
            <datepicker
                    placeholder="Select end date"
                    id="end_date"
                    name="end_date"
                    :min-date="minEndDate"
                    :max-date="maxEndDate"
                    v-model="end_date"
            />
        </form-group>
    </div>
</template>

<script>
    import moment from 'moment'
    import api from '@/api'
    import NeedsUsers from '@/mixins/NeedsUsers'

    export default {
        mixins: [NeedsUsers],

        props: ['type', 'startDate', 'endDate', 'attachedUser'],

        data() {
            return {
                attached_employee_user: '',
                start_date: null,
                end_date: null,
            }
        },

        mounted() {
            if (this.startDate) {
                this.start_date = this.startDate
            }
            if (this.endDate) {
                this.end_date = this.endDate
            }
            if (this.attachedUser) {
                this.attached_employee_user = this.attachedUser
            }
        },

        methods: {},

        computed: {

            userList() {
                return this.users
                    .filter(user => !user.is_current_user)
                    .sort((a, b) => a.name > b.name ? 1 : -1);
            },

            minStartDate() {
                if (this.type == 'duty-swap') {
                    return moment().add(3, 'days').format('YYYY-MM-DD');
                }
                return moment().add(2, 'months').startOf('month').format('YYYY-MM-DD');
            },

            maxStartDate() {
                if (this.type == 'duty-swap') {
                    if (moment().format('D') >= 14) {
                        return moment().startOf('month').add(2, 'months').add(4, 'days').format('YYYY-MM-DD')
                    }
                    return moment().startOf('month').add(1, 'months').add(4, 'days').format('YYYY-MM-DD')
                }
                return null;
            },

            minEndDate() {
                return moment().format('YYYY-MM-DD');
            },

            maxEndDate() {
                if (this.type == 'duty-swap') {
                    if (moment().format('D') >= 14) {
                        return moment().startOf('month').add(2, 'months').add(4, 'days').format('YYYY-MM-DD')
                    }
                    return moment().startOf('month').add(1, 'months').add(4, 'days').format('YYYY-MM-DD')
                }
                if (this.type == 'pattern-flying' || this.type == 'buddy-flying') {
                    if (moment().format('D') >= 14) {
                        return moment().add(4, 'months').startOf('month').format('YYYY-MM-DD')
                    }
                    return moment().add(3, 'months').startOf('month').format('YYYY-MM-DD')
                }
                return null;
            },

        },

        watch: {
            end_date(val) {
                if (val) {
                    this.$parent.$emit('completed')
                }
            }
        }

    }
</script>
